<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case
      code="engagement-normes"
      v-model="inscriptionAuRegistreEtudiantsCandidats.jeMEngageARespecterLesNormes"
      :live="liveSasEtudiantCandidat(1939)"
    ></opq-case>
    <opq-case
      code="engagement-assurance"
      v-model="inscriptionAuRegistreEtudiantsCandidats.engagementAssuranceCouverte"
      :live="liveSasEtudiantCandidat(1903)"
    ></opq-case>
    <opq-case
      code="engagement-informer"
      v-model="inscriptionAuRegistreEtudiantsCandidats.engagementInformerOrdre"
      :live="liveSasEtudiantCandidat(1904)"
    ></opq-case>
    <opq-case
      code="autorise-université"
      v-model="inscriptionAuRegistreEtudiantsCandidats.autoriseUniveriste"
      :live="liveSasEtudiantCandidat(1905)"
    ></opq-case>
    <opq-case
      code="autorise-ordre-communiquer"
      v-model="inscriptionAuRegistreEtudiantsCandidats.autoriseCommunication"
      :live="liveSasEtudiantCandidat(1906)"
    ></opq-case>
    <opq-case
      code="autorise-ordre-inclure"
      v-model="inscriptionAuRegistreEtudiantsCandidats.autoriseInclureCoordonnees"
      :live="liveSasEtudiantCandidat(1907)"
    ></opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    inscriptionAuRegistreEtudiantsCandidats() {
      return this.sas.sasEtudiantCandidat
    }
  },
  methods: {
    liveSasEtudiantCandidat(cle) {
      return { endpoint: "/sas-etudiant-candidat/", cle: cle, fileId: this.inscriptionAuRegistreEtudiantsCandidats.id }
    }
  }
}
</script>

<style>
</style>